import React from 'react';
import { Box, Chip } from '@mui/material';
import TouchTooltip from '../../common/TouchTooltip';
import { formatSizeChipTooltip } from '../../../utils/buyerInsightsFormat';

// Chip styles per state (spec §2.6): in stock plain · sold out struck through · only you green ·
// never bought in dashed blue. Status is as of End; the tooltip says so.
export const chipSx = (status) => {
  switch (status) {
    case 'sold_out':
      return { textDecoration: 'line-through', color: 'text.disabled', borderColor: '#e0e0e0' };
    case 'only_you':
      return { bgcolor: '#e8f5e9', borderColor: '#2e7d32', color: '#1b5e20', fontWeight: 600 };
    case 'never_bought':
      return { borderStyle: 'dashed', borderColor: '#1976d2', color: '#1976d2' };
    default:
      return { borderColor: '#bdbdbd' };
  }
};

const SizeStatusChips = ({ sizes, end }) => {
  if (!sizes || sizes.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {sizes.map((s) => (
        <TouchTooltip key={s.size_id || s.label} title={formatSizeChipTooltip(s, end)}>
          <Chip label={s.label} size="small" variant="outlined" sx={{ fontSize: '0.75rem', height: 22, ...chipSx(s.status) }} />
        </TouchTooltip>
      ))}
    </Box>
  );
};

export default SizeStatusChips;
